import { Component, Input, OnInit, Output, EventEmitter, AfterViewInit } from "@angular/core";
import { AuthorizationPipe } from "../../common/pipes/authorization.pipe";
import { AutoshipResponse } from "../interface/autoship";
import { ProductInformation } from "../interface/product-info";
import { OrderDetailInformation } from "../interface/order-detail-info";
import { ProfileOrderResponse } from "../interface/profile-order-response";
import { OrderResponse } from "../interface/order-response";
import { BillingInformation } from "../interface/billing-info";
import { ShippingInformation } from "../interface/shipping-info";
import { AddressInformation } from "../interface/address-detail-info";
import { CustomerService } from "../services/customer.service";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { RowStatus } from "../../shared/common/enumerations";
import { NotificationType } from '../enums/notification-types.enum';
import { CustomerServiceConstants } from "../../common/constants/customer-service.constants";
import { AutoshipMemberInfo } from "../interface/autoship-memberinfo";
import { OrderService } from "../services/order.service";
import { CommonService } from "../../shared/services/common.service";
import { TaxRequest } from "../interface/tax-request";
import { CurrencyTransformPipe } from "../../common/pipes/currency-format.pipe";
import { OrderSourceType, ShippingOrderType, PriceType, ShippingType, Source, ProductWeightMetric, PaymentMethodTypes, OrderStatus, PaymentType } from '../enums/order-source-type';
import { StatusConstants } from '../constants/status.constants';
import { PersonalInfoConfigService } from './../services/personal-info-config.service';
import { PersonalInfoConfig } from '../interface/personal-info-config.interface';
import { ShippingAddressInfoConfig } from '../interface/shipping-address-info-config.interface';

@Component({
    selector: "autoship",
    templateUrl: "../templates/template1/views/autoship.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/search.less",
        "../templates/template1/themes/default/css/profile-info.less"
    ],
    providers: [AuthorizationPipe]
})
export class AutoshipComponent implements OnInit, AfterViewInit {
    @Input() memberId: string;
    @Input() autoshipTabInfo: AutoshipMemberInfo;
    sortColumn: string = "scheduledRunDay";
    sort: String = "DESC";
    autoships: AutoshipResponse[];
    pageNumber: number = 1;
    pageSize: number = 10;
    pageCount: number = 0;
    isDesc: boolean = false;
    isautoShipDetail: boolean = false;
    address: string = " Address information";
    //   products: ProductInformation[];
    orderSummary: OrderDetailInformation;
    autoShipHistory: any;
    fboOrderDetails: any;
    orderInformation: any;
    _id: string;

    autoshipSortColumn = "date";
    autoshipIsDesc = false;
    autoShipInfo: any[] = [];
    STATUS: any = CustomerServiceConstants.AUTOSHIP_STATUS;
    autoshipStatus: number = 0;
    allAutoShipsInfo: any;
    memberAddress: any;
    shippingAddress: any;
    billingAddress: any;
    selecteAutoShip: any;
    countries: any;
    states: any;
    productsInfo: any;
    orderTaxValid: boolean = false;
    isVerifiedAddress: boolean = false;
    shippingTotal = 0;
    orderTaxResponse: any;
    taxableAmount = 0;
    orginalShippingCost = 0;
    isShippingWaived: boolean = false;
    waivedShippingCost = 0;
    searchReqValues: any;
    storeInfo: any;
    paymentDetails: any;
    subTotal = 0;
    totalCommissionableVolume: number = 0;
    shipMethods: any;
    shippingMethods: any[] = [];
    deliverypreferenceId: any;
    autoshipShipMethodId: any;
    shippingCharge = 0;
    pollCount = 0;
    maxPollCount = 15;
    shippingAddressInfoConfig: ShippingAddressInfoConfig;
    homeCountry:any;
    constructor(private _customerservice: CustomerService
        , private route: ActivatedRoute
        , private router: Router
       , private _currencyPipe: CurrencyTransformPipe,
        private _orderService: OrderService,
        private _commonService: CommonService,
        private _personalInfoConfigService: PersonalInfoConfigService
    ) { }

    ngOnInit(): void {
      //  this.memberId="3";
        this.route.params.subscribe((params: Params) => {
            this._id = params["id"];
        });
        this.orderSummary = new OrderDetailInformation();

        //this.GetProductDetails(0);
        // this. GetOrderSummary(0);

        this.fboOrderDetails = new ProfileOrderResponse();
        this.fboOrderDetails.orders = new Array<OrderResponse>();  
        this.getStoreInfo(this.autoshipTabInfo.homeCountry);
        this.getProfileInfo();
        this.getAllAutoships();
        this.getAllCountries();
        this.getAllStates();
        this.orderInformation = new OrderDetailInformation();
        this.orderInformation.billingInfo = new BillingInformation();
        this.orderInformation.shippingInfo = new ShippingInformation();
        this.orderInformation.productInfo = new Array<ProductInformation>();
        this.orderInformation.billingInfo.address = new AddressInformation();
        this.orderInformation.shippingInfo.address = new AddressInformation();
        this.homeCountry = this.autoshipTabInfo.homeCountry;
    }
    ngAfterViewInit(): void {
        this.getMemberAddress();
    }

    /**
    * sort table by respective column --- not hits service
    * @param sortColumn 
    */
    sortAutoshipTableByColumn(sortColumn: string) {
        this.isDesc = (this.sortColumn == sortColumn || sortColumn == "") ? !this.isDesc : this.isDesc;
        this.autoships.sort((a: any, b: any) => {
            if (a[sortColumn] > b[sortColumn])
                return this.isDesc ? -1 : 1;

            if (a[sortColumn] < b[sortColumn])
                return this.isDesc ? 1 : -1;
        });
        this.sortColumn = sortColumn;
    }

    backtoAutoShipHistory() {
        this.isautoShipDetail = false;
        this.clearSortOptions();
    }

    /* 
    get all auto ships for the member
     */
    // getAllAutoships() {
    //     this._customerservice.getAllAutoships(this._id).subscribe(response => {
    //         if (response) {
    //             this.autoships = response;
    //         }
    //     });
    // }

    /* 
    retreiving particular auto ship information
    */
    AutoshipDetails(templateId: string) {
        this.isautoShipDetail = true;
        this.clearSortOptions();
        this.getAutoShipInformation(templateId);
        this.GetAutoshipHistory(templateId);
    }

    /* 
    get autoship history of particular autoship id
    */

    GetAutoshipHistory(templateId: string) {
        this.autoShipHistory = [{ date: "12/31/2017", status: "Shipped", details: "Declined", code: "Approved" },
        { date: "11/30/2017", status: "Processed", details: "Declined", code: "Approved" }]
    }
    /* 
     get all the products of particular autoship
    */
    GetProductDetails(templateId: number) {

        // this.products = [{
        //     sku: "product_123",
        //     productDescription: "Product1",
        //     unitPrice: 100.00, quantity: 2, cc: 3.12, price: 200
        // },
        // {
        //     sku: "product_224",
        //     productDescription: "Product2",
        //     unitPrice: 100.00, quantity: 2, cc: 3.12, price: 200
        // }
        // ]
    }

    /** ****************** HITS SERVICES   ----- BEGIN ----- ************************* */
    /**
     * Gets fbo / retail profile detail
     */
    getProfileInfo(url?: string) {
        this._customerservice.getProfileOrderDetails(this._id, false, this.pageNumber, this.pageSize,
             this.sort, this.sortColumn, '', '', '', url).subscribe(response => {
            if (response) {
                if (response.status === StatusConstants.COMPLETED) {
                    this.getAutoshipOrderDetails(response);
                } else {
                    this.fetchAutohipOrderDetails(response);
                }
            }
        });
    }

        /**
     * @description
     * @date 2019-05-08
     * @param {*} response
     * @memberof AutoshipComponent
     */
    getAutoshipOrderDetails(response: any) {
        this.pageCount = response.recordsCount;
        this.fboOrderDetails = response;
        if (this.fboOrderDetails.orders) {
            this.fboOrderDetails.orders.forEach((orderData: any) => {
                orderData.orderDate = new Date(orderData.orderDate);
            });
        } else {
            this.fboOrderDetails.orders = new Array<OrderResponse>();
        }
    }

    /** fetch Order details
     * @description
     * @date 2019-05-08
     * @param {*} response
     * @memberof AutoshipComponent
     */
    fetchAutohipOrderDetails(response: any) {
        if ((response.status === StatusConstants.IN_PROGRESS) || (response.status === StatusConstants.QUEUED)) {
            if (this.pollCount < this.maxPollCount) {
                this.pollCount = this.pollCount + 1;
                this.getProfileInfo(response.location);
            }
        }
    }

    /**
     * Gets fbo / retail oder information
     */
    getAutoShipInformation(templateId: string) {
        this.isDesc = false;    // Using for 2 tables so updating to false...
        this.sortColumn = "";
        this.isautoShipDetail = true;
        this._customerservice.getAutoShipDetail(templateId).subscribe(response => {
            if (response) {
                this.orderInformation = response;
                this.orderInformation.orderDate = new Date(this.orderInformation.orderDate);

                //verifying wether respective fields are undefined or not.. if undefined assigning respective model
                if (!this.orderInformation.billingInfo) {
                    this.orderInformation.billingInfo = new BillingInformation();
                    this.orderInformation.billingInfo.address = new AddressInformation();
                }
                if (!this.orderInformation.shippingInfo) {
                    this.orderInformation.shippingInfo = new ShippingInformation();
                    this.orderInformation.shippingInfo.address = new AddressInformation();
                }
                else {
                    this.orderInformation.shippingInfo.shippingDate = new Date(response.shippingInfo.shippingDate);
                }
                if (!this.orderInformation.productInfo) {
                    this.orderInformation.productInfo = new Array<ProductInformation>();
                }
            }
        });
    }

    /**
     * clear sort option on navigating to forth & Back (Autoship summary page & Autoship details page)
     */
    clearSortOptions() {
        this.sortColumn = this.isautoShipDetail ? "sku" : "scheduledRunDay";
        this.sort = "DESC";
        this.pageNumber = 1;
        this.pageSize = 10;
        this.pageCount = 0;
        this.isDesc = false;
    }

    /**
    * sorting of columns (product information table) // not hits service...
    * @param sortColumn 
    */
    sortProductInformationByColumn(sortColumn: string) {
        this.isDesc = (this.sortColumn == sortColumn || sortColumn == "") ? !this.isDesc : this.isDesc;
        this.orderInformation.productInfo.sort((a: any, b: any) => {
            if (a[sortColumn] > b[sortColumn])
                return this.isDesc ? -1 : 1;

            if (a[sortColumn] < b[sortColumn])
                return this.isDesc ? 1 : -1;
        });
        this.sortColumn = sortColumn;
    }

    /**
   * sorting of columns for autoship history table // not hits service...
   * @param sortColumn 
   */
    sortAutoshipHistoryByColumn(sortColumn: string) {
        this.autoshipIsDesc = (this.autoshipSortColumn == sortColumn || sortColumn == "") ? !this.autoshipIsDesc : this.autoshipIsDesc;
        this.autoShipHistory.sort((a: any, b: any) => {
            if (a[sortColumn] > b[sortColumn])
                return this.autoshipIsDesc ? -1 : 1;

            if (a[sortColumn] < b[sortColumn])
                return this.autoshipIsDesc ? 1 : -1;
        });
        this.autoshipSortColumn = sortColumn;
    }
    /*
    get autoship details
    */
    getAllAutoships() {
        this._customerservice.getAllAutoships(this.autoshipTabInfo.memberId,this.autoshipTabInfo.homeCountry)
            .subscribe(response => {
                if (response && response.length > 0) {
                    this.allAutoShipsInfo = response[0].body;
                    this.autoShipInfo = this.allAutoShipsInfo.filter((autoship: any) => autoship.autoshipStatusId === RowStatus.Active || autoship.autoshipStatusId === RowStatus.InActive);
                }
                else{
                    this.autoShipInfo = [];
                }
            });
    }
    getAutoshipInfo(autoship: any) {
        
        this.selecteAutoShip = autoship;
        this.billingAddress = null;
        this.shippingAddress = null;
        this.getProductsinfo();
        this.isautoShipDetail = true;
        if (autoship.autoshipShippingInformations && autoship.autoshipShippingInformations.length > 0) {
            this.deliverypreferenceId = autoship.autoshipShippingInformations[0].deliverypreferenceId;
            this.autoshipShipMethodId = autoship.autoshipShippingInformations[0].shipMethodId;
            let shippingAddressId = autoship.autoshipShippingInformations[0].shippingAddressId;
            if (shippingAddressId) {
                let address: any = this.memberAddress.find((item: any) => shippingAddressId === item.id);
                let state = this.states.find((state: any) => state.id === address.stateId);

                let country = this.countries.find((country: any) => country.countryId === address.countryId);

                this.shippingAddress = {
                    addressLine1: address.addressLine1,
                    addressLine2: address.addressLine2,
                    city: address.city,
                    stateId: address.stateId,
                    stateName: state ? state.stateName : '',
                    stateCode: state ? state.stateCode : '',
                    countryName: country ? country.name : '',
                    countryCode: country ? country.isocodeThree : '',
                    countryId: address.countryId,
                    postalCode: address.postalCode,
                    shipToName: ''
                }
            }           
        }
        if (autoship.autoshipPayments && autoship.autoshipPayments.length > 0) {
            let billingAddressId = autoship.autoshipPayments[0].billingAddressId;
            if (billingAddressId) {
                this.billingAddress = this.memberAddress.find((address: any) => billingAddressId === address.id);
                let state = this.states.find((state: any) => state.id === this.billingAddress.stateId);
                this.billingAddress.state = state ? state.stateName : '';
                let country = this.countries.find((country: any) => country.countryId === this.billingAddress.countryId);
                this.billingAddress.country = country ? country.isocodeThree : '';
            }
            this.getDistributorCardPayments(autoship.autoshipPayments[0].paymentInstrumentId);
        }

    }
    /*
    get autoship details
    */
    onFilterStatus() {
        if (+this.autoshipStatus === RowStatus.Active) {
            this.autoShipInfo = this.allAutoShipsInfo.filter((autoship: any) => autoship.autoshipStatusId === RowStatus.Active);
        }
        else if (+this.autoshipStatus === RowStatus.InActive) {
            this.autoShipInfo = this.allAutoShipsInfo.filter((autoship: any) => autoship.autoshipStatusId === RowStatus.InActive);
        }
        else {
            this.autoShipInfo = this.allAutoShipsInfo.filter((autoship: any) => autoship.autoshipStatusId === RowStatus.Active || autoship.autoshipStatusId === RowStatus.InActive);
        }
    }
    /*
     get address using memberId to map with autoship address
     */
    getMemberAddress() {
        this._customerservice.getMemberAddress(this.autoshipTabInfo.memberId)
            .subscribe(response => {
                this.memberAddress = response;
            });
    }
    /*
 get all countries
 */
    getAllCountries() {
        this._customerservice.getAllCountries(true)
            .subscribe(response => {
                this.countries = response;
            });
    }


    /*
get all countries
*/
    getAllStates() {
        this._customerservice.getAllStates()
            .subscribe(response => {
                this.states = response;
            });
    }

    /*
get all countries
*/
    getProductsinfo() {
        
        let storeId = this.selecteAutoShip.storeId;
        let memberLevel = this.autoshipTabInfo.memberLevelId;
        let products = this.selecteAutoShip.autoshipProducts.map((a: any) => a.productId);
        this._customerservice.getProductsinfo(this.autoshipTabInfo.homeCountry, storeId, memberLevel, products, this.storeInfo.taxInclusive)
            .subscribe(response => {
                if (response && response.length > 0) {
                    this.productsInfo = response;
                    this.productsInfo.forEach((item: any) => {
                        let product = this.selecteAutoShip.autoshipProducts.find((product: any) => product.productId === item.id);
                        item.quantity = product.quantity;
                        this.subTotal = this.subTotal + (item.applicablePrice* item.quantity);
                        this.totalCommissionableVolume = this.totalCommissionableVolume + (item.commissionableVolume * +item.quantity);
                    });
                     this.getShipMethods();
                }

            });
    }


    calculateOrderTax(): void {
        
        this.orderTaxValid = false;
        if (this.autoshipTabInfo.memberId && this.storeInfo && this.productsInfo && this.productsInfo.length > 0) {
            //   this.shippingTotal = this.orderFormGroup.value.shippingCost;
            const taxRequest: TaxRequest = this.prepareTaxRequest();
            this._orderService.calculateOrderTax(taxRequest)
                .subscribe((taxResponse: any) => {
                    if (taxResponse && taxResponse.success) {
                        if (taxResponse.cart && taxResponse.cart.totalTax >= 0) {
                            taxResponse.cart.totalTax = this._currencyPipe.getFormatedCurrency(taxResponse.cart.totalTax, this.storeInfo);
                            this.orderTaxResponse = taxResponse;
                            this.taxableAmount = taxResponse.cart.totalTax;
                        }
                    } else {
                        this.orderTaxValid = false;
                    }
                },
                (err: any) => {
                    this.orderTaxValid = true;
                });

        }
    }
    getStoreInfo(countryCode: any) {
        if (countryCode) {
            this._orderService.getStoreInfo(countryCode).subscribe(response => {
                if (response) {
                    this.storeInfo = response;
                    // if (this.memberId) {
                    //     this.getSavedCards(this.memberId, countryCode);
                    // }

                }
            }, error => {
                let notification: any = "order. Unable to fetch Store Details";
                this._commonService.createNotification("", notification.value, NotificationType.ERROR);
            })
        }

    }

    getDistributorCardPayments(paymentDetailID: any) {
        
        this._customerservice.getSavedCardDetails(this.autoshipTabInfo.memberId, this.autoshipTabInfo.homeCountry).subscribe(response => {
         
            if (response) {
                this.paymentDetails = response.savedCards.find((item: any) => item.id === paymentDetailID);
            }
            else {
                this.paymentDetails = null;
            }
        });
    }

    private prepareTaxRequest(): TaxRequest {
        const taxRequest: TaxRequest = {
            orderID: 0,
            memberID: +this.autoshipTabInfo.memberId,
            shopingCart: this.mapCartToTaxCart(),
            fromAddress: this.getWarehouseAddress(),
            toAddress: this.getShippingAddress(),
            memberNumber: null,
            orderNumber: 0,
            storeID: this.storeInfo.id,
            priceTierName: this.getPriceTier(),
            currencyCode: this.storeInfo.currencyCode,
            countryCode: this.autoshipTabInfo.homeCountry.toLowerCase(),
            deliveryTypeId: this.selecteAutoShip.deliverypreferenceId,
            orderSource: "CUSTOMER SERVICE",
            orderTypeId: 2,
            conversionRate: 1,
            memberLevelId: this.autoshipTabInfo.memberLevelId,
            wholesaleQualified: this.autoshipTabInfo.wholesaleQualified,
            memberType: ''
        };
        return taxRequest;
    }
    /**
      * @returns TaxCart
      */
    private mapCartToTaxCart(): any {
        const taxCart: any = {
            shippingTax: 0,
            importFeeValue: 0,
            shipMethodId: this.selecteAutoShip.shipMethodId,
            shippingCost: this.shippingCharge,
            orderLineItems: this.mapItemstoTaxItems()
        };
        return taxCart;
    }
    private getPriceTypeId(): PriceType {
        // if (UserTitleType.RETAIL !== this.userTitleType) {
        //   return PriceType.WHOLESALEPRICE;
        // } 
        return PriceType.WHOLESALEPRICE;
        // else {
        //   return PriceType.RETAILPRICE;
        // }
    }
    /**
   * Selected Shipping Address
   */
    getShippingAddress(): any {
        let shippingAddress: any = {
            addressLine1: this.shippingAddress.addressLine1,
            addressLine2: this.shippingAddress.addressLine2,
            city: this.shippingAddress.city || null,
            state: this.shippingAddress.stateCode,
            stateCode: this.shippingAddress.stateCode,
            countryCode: this.shippingAddress.countryName,
            country: this.shippingAddress.countryName,
            postalCode: this.shippingAddress.postalCode,
            zip: this.shippingAddress.postalCode,
            countryId: this.shippingAddress.countryId,
            stateId: this.shippingAddress.stateId
            // addressLine1: '8031 Turkey Lake Rd Ste 700',
            // addressLine2: '',
            // city: 'Orlando',
            // state: 'FL',
            // stateCode: 'FL',
            // countryCode: 'USA',
            // country: 'USA',
            // postalCode: '32819-7386',
            // zip: '32819-7386',
            // countryId: 1,
            // stateId: 373,
            // name: '',
            // addressType: 40
        }
        return shippingAddress;
    }
    /**
     * Store Ware house Address
     */
    getWarehouseAddress(): any {
        if (this.storeInfo && this.storeInfo.warehouseAddress) {
            let warehouseAddress: any = {
                addressLine1: this.storeInfo.warehouseAddress.addressLine1,
                addressLine2: this.storeInfo.warehouseAddress.addressLine2,
                city: this.storeInfo.warehouseAddress.city,
                state: this.storeInfo.warehouseAddress.stateCode,
                stateCode: this.storeInfo.warehouseAddress.stateCode,
                countryCode: this.storeInfo.warehouseAddress.countryCode,
                country: this.storeInfo.warehouseAddress.countryCode,
                postalCode: this.storeInfo.warehouseAddress.zipCode,
                zip: this.storeInfo.warehouseAddress.zipCode,
                countryId: this.storeInfo.warehouseAddress.countryId,
                stateId: this.storeInfo.warehouseAddress.stateOrProvinceId,
                name: null
            }
            return warehouseAddress;
        }

    }


    /**
     * @returns CartItems
     */
    private mapItemstoTaxItems(): any[] {
        const taxItems: any[] = [];
        if (this.productsInfo && this.productsInfo.length > 0) {
            let itemLineNumber = 0;
            this.productsInfo.forEach((x: any) => {
                const taxItem: any = {
                    lineNumber: ++itemLineNumber,
                    itemNumber: x.itemNumber,
                    taxablePrice: x.applicablePrice,
                    quantity: +x.quantity,
                    taxCode: null,
                    description: '',//"testing",
                    taxInclusive: false,
                    resale: false,
                    resalePrice: 0,
                    taxBreakDown: x.taxBreakDown,
                    productIdentifier: null,
                    retailPrice: x.retailPrice,
                    paidPrice: x.applicablePrice,
                    wholeSalePrice: x.wholesalePrice,
                    salesTax: 0,
                    revisionNumber: x.revisionNumber,
                    itemWeight: x.shipping && x.shipping.weight ? x.shipping.weight : 0,
                    importedMeasurementUnit: x.importedMeasurementUnit
                };
                taxItems.push(taxItem);
            });
        }
        return taxItems;
    }


    getPriceTier() {
        let priceTierName = '';
        if (this.productsInfo && this.productsInfo.length > 0) {
            priceTierName = this.productsInfo[0].priceTierName;
        }
        return priceTierName;
    }

    getShipMethods() {

        if (this.autoshipTabInfo.memberId && this.storeInfo && this.productsInfo) {
            const languageCode: string = 'en-US';
            let shippingOptions: any = {
                productModels: this.getProductModels(),
                orderSourceId: OrderSourceType.Web,
                languageCode: languageCode,
                orderTypeId: ShippingOrderType.Personal,
                fromAddress: this.getWarehouseAddress(),
                toAddress: this.getShippingAddress(),
                storeId: this.storeInfo.id,
                requestID: 2, // for now we are using two once config is done we will drive from enum
                memberTypeId: 4,
                priceTypeId: this.getPriceTypeId(),
                memberLevelId: this.autoshipTabInfo.memberLevelId,
                orderSubTotal: this.subTotal,
                orderCaseCredits: this.totalCommissionableVolume,
                purchaseFlowId: this.getPriceTypeId(),
                shippingTypeId: this.deliverypreferenceId,
                storeHomeCountryCode: this.autoshipTabInfo.homeCountry,
            };
            //order source only for AUT && DEU Country
            if(this.shippingAddressInfoConfig.sendSourceToShippingOptions){
                shippingOptions.source = Source.CSP;
            }
            this._orderService.getShipmentService(shippingOptions).subscribe(response => {

                if (response && response.shippingMethods) {
                    this.shipMethods = response;
                    this.shippingMethods = response.shippingMethods;
                    if (this.shippingMethods.length > 0) {
                        let shippingObj = this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === this.autoshipShipMethodId)[0];

                        if (shippingObj) {
                            this.shippingCharge = shippingObj.shippingCharge;
                            this.calculateOrderTax();
                        }

                    }
                    
                } else if (response && response.validations.length > 0) {
                    // this.shipMethodValidation = response.validations[0];

                }
            }, error => {
                // let notification: any = this._translatePipe.get("order. Unable to fetch Ship Methods");
                // this._commonService.createNotification("", notification.value, "error");
            })
        }

    }

    private getProductModels(): any[] {

        const productModels: any[] = [];
        if (this.productsInfo && this.productsInfo.length > 0) {

            for (var index = 0; index < this.productsInfo.length; index++) {

                let product = this.productsInfo[index];

                if (product) {

                    const productModel: any = {
                        productID: product.id,
                        productHeight: product.shipping.height,
                        productWeight: product.shipping.weight,
                        productQuantity: product.quantity,
                        productLength: product.shipping.length,
                        productWidth: product.shipping.width,
                        wholesalePrice: product.wholesalePrice,
                        sellingPrice: product.applicablePrice,
                        isOrderLiteratureOnly: product.literature,
                        retailPrice: product.retailPrice,
                        weightMetricId: ProductWeightMetric.KGS,
                        isShippable: product.shipping.shippingRequired,
                        itemNumber: product.itemNumber
                    };
                    productModels.push(productModel);

                }

            }

        }
        return productModels;
    }
  calculateOrderTotal(): any {
        return this._currencyPipe.getFormatedCurrency(( (+this.subTotal) + (+this.shippingCharge) + (+this.taxableAmount)), this.storeInfo);
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/autoship.component.ts